import {
  japaneseTheme,
  KdsThemeProvider,
  lightTheme,
} from "@kazaar-platform/design-system";
import { useAtom } from "jotai/react";
import { type PropsWithChildren, useEffect } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { MeReadDtoLangEnum } from "@/config/apiClient";
import { router } from "@/pages/Routes";
import { userAtom } from "@/store";
import { tolgee } from "./TranslationProvider";

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [userAtomValue] = useAtom(userAtom);

  const isJapanese = userAtomValue?.lang === MeReadDtoLangEnum.Jp;

  const getVanillaTheme = () => {
    const theme = [lightTheme];
    if (isJapanese) {
      theme.push(japaneseTheme);
    }
    return theme.join(" ");
  };

  useEffect(() => {
    const themeClasses = getVanillaTheme().split(" ");
    const bodyClassname = isJapanese ? "japanese" : "kazaar";

    document.body.classList.add(...themeClasses, bodyClassname);

    if (isJapanese) {
      void import("../fonts-jp.css");
    }

    return () => {
      document.body.classList.remove(...themeClasses, bodyClassname);
    };
  }, [isJapanese]);

  return (
    <KdsThemeProvider
      navigate={(path: string) => void router.navigate(path)}
      t={tolgee.t}
      theme={getVanillaTheme()}
    >
      <SkeletonTheme baseColor="#E2E8F0" highlightColor="#F1F5F9">
        {children}
      </SkeletonTheme>
    </KdsThemeProvider>
  );
};
